import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { Button } from "components/DesignSystem/Button/Button";
import { LockedButton } from "components/DesignSystem/Button/LockedButton";
import { InvoiceCustomerModal } from "components/InvoiceCustomerModal/InvoiceCustomerModal";
import { ReactNode } from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import { parse, stringify } from "qs";
import { Customers as CustomersPage } from "pages/Books/Customers/Customers";
import { InvoiceCustomerInfo } from "pages/Books/Customers/InvoiceCustomerInfo";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { useModal } from "hooks/useModal";
import { LockedUi } from "components/LockedUi/LockedUi";

const Layout = ({ children }: { children: ReactNode; url: string }) => {
  const addCustomerModal = useModal();

  return (
    <>
      <DashboardLayout
        header={
          <Header
            v2
            title="Customers"
            right={
              <LockedUi
                feature={WRITE_PERMISSION_KEYS.REVENUE}
                blockedUi={<LockedButton text="Add customer" size="xsmall" />}
              >
                <Button
                  onClick={addCustomerModal.open}
                  size="xsmall"
                  customType="primary"
                >
                  Add customer
                </Button>
              </LockedUi>
            }
          />
        }
      >
        {children}
      </DashboardLayout>
      <InvoiceCustomerModal
        customerId={addCustomerModal.isOpen ? "NEW" : null}
        setCustomerId={() => addCustomerModal.close()}
      />
    </>
  );
};

export const Customers = () => {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const parsedSearch = parse(location.search, { ignoreQueryPrefix: true });

  const search = stringify(
    {
      entity: parsedSearch.entity,
      company: parsedSearch.company,
    },
    { skipNulls: true, addQueryPrefix: true }
  );

  return (
    <Switch>
      <Route path={`${path}/:customerId`}>
        <InvoiceCustomerInfo
          breadcrumbs={[
            {
              name: "Customers",
              link: `${url}${search}`,
            },
          ]}
        />
      </Route>

      <Route path={path}>
        <Layout url={url}>
          <CustomersPage />
        </Layout>
      </Route>
    </Switch>
  );
};
